module.exports = __webpack_public_path__ + "img/login-logo.5a68b432.png";